import {ReactNode, useState} from "react";
import QRCodeFolderDialogContext from "./QRCodeFolderDialogContext";
import SimpleQRCode from "../../../../api/qr-code/SimpleQRCode";

type Props = { children: ReactNode };

function WrapQRCodeFolderDialogContext(props: Props) {
    /**
     * QRCode
     * @since 0.1.9
     * @author Kacper Faber
     */
    const [qrCode, setQRCode] = useState<SimpleQRCode>();

    /**
     * Open the dialog by setting the QRCode state.
     * @since 0.1.9
     * @author Kacper Faber
     */
    const open = (qrCode: SimpleQRCode) => {
        setQRCode(qrCode);
    }

    /**
     * Unset the QRCode state, and closes the dialog this way.
     * @since 0.1.9
     * @author Kacper Faber
     */
    const close = () => {
        setQRCode(undefined);
    }

    /**
     * Check if dialog is opened
     * @since 0.1.9
     * @author Kacper Faber
     */
    const isOpened = () => {
        return qrCode !== undefined;
    }

    return (
        <QRCodeFolderDialogContext.Provider
            value={{ isOpened: isOpened(), close, qrCode, open }}
            children={props.children}
        />
    );
}

export default WrapQRCodeFolderDialogContext;